module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row heading"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('paginate', {
    attrs: {
      "page-count": _vm.num_pages,
      "initial-page": _vm.paginate.current_page - 1,
      "page-range": 1,
      "margin-pages": 1,
      "click-handler": _vm.paginateClick,
      "container-class": "pagination",
      "page-class": "page-item",
      "page-link-class": "page-link",
      "prev-class": "page-item",
      "prev-link-class": "page-link",
      "next-class": "page-item",
      "next-link-class": "page-link"
    }
  })], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row lined"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showAddNote),
      expression: "!showAddNote"
    }],
    staticClass: "col"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.setAddNote
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  Add Note")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddNote),
      expression: "showAddNote"
    }],
    staticClass: "col"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newNote.note),
      expression: "newNote.note"
    }],
    ref: "noteField",
    staticClass: "form-control",
    attrs: {
      "rows": "3"
    },
    domProps: {
      "value": _vm._s(_vm.newNote.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newNote.note = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-clear",
    on: {
      "click": function($event) {
        _vm.showAddNote = false;
      }
    }
  }, [_vm._v("Cancel\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addNote($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("  Save Note")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])]), _vm._v(" "), _vm._l((_vm.leadCarrierNotes), function(n, i) {
    return _c('div', {
      key: n.leadCarrierNote_id,
      staticClass: "row lined"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.selected || _vm.selected.leadCarrierNote_id != n.leadCarrierNote_id),
        expression: "!selected || selected.leadCarrierNote_id != n.leadCarrierNote_id"
      }],
      staticClass: "col-3"
    }, [_vm._v("\n      " + _vm._s(_vm._f("formatDate")(n.timestamp)) + "\n    ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.selected || _vm.selected.leadCarrierNote_id != n.leadCarrierNote_id),
        expression: "!selected || selected.leadCarrierNote_id != n.leadCarrierNote_id"
      }],
      staticClass: "col-3"
    }, [_vm._v("\n      " + _vm._s(n.user_name) + "\n    ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.selected || _vm.selected.leadCarrierNote_id != n.leadCarrierNote_id),
        expression: "!selected || selected.leadCarrierNote_id != n.leadCarrierNote_id"
      }],
      staticClass: "col-4"
    }, [_vm._v("\n      " + _vm._s(n.note) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-2 text-right"
    }, [_c('dropdown-confirmation', {
      attrs: {
        "title": "Are you sure you want to delete this note?"
      },
      on: {
        "confirm": function($event) {
          _vm.deleteNote(n)
        }
      }
    })], 1)])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h2', [_vm._v("Notes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row table-head"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Note")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33eb18d9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/leads/LeadCarrierNotes.vue
// module id = 377
// module chunks = 0